module.exports = __webpack_public_path__ + "static/media/1921-14.431ca062.png";